import { render, staticRenderFns } from "./SalaryConfig.vue?vue&type=template&id=1c807e71&scoped=true"
import script from "./SalaryConfig.vue?vue&type=script&lang=js"
export * from "./SalaryConfig.vue?vue&type=script&lang=js"
import style0 from "./SalaryConfig.vue?vue&type=style&index=0&id=1c807e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c807e71",
  null
  
)

export default component.exports